// extracted by mini-css-extract-plugin
module.exports = {"navSecond":"DropList_navSecond__1fzXe","title":"DropList_title__3aORw","list":"DropList_list__1bP2e"};